import "./Hero.scss";
import ButtonSecondary from "../../components/shared/ButtonSecondary";

import HeroCrystal from "../../assets/images/hero-crystal.png";
import CrystalScene from "../../components/Home/CrystalScene";

export default function Hero() {
	return (
		<>
			<div className="hero">
				<div className="hero-content-wrapper content-wrapper-lg">
					<div className="hero-content">
						<span className="hero-title title-1">UNLOCK</span>
						<span className="hero-title title-2">Market</span>
						<span className="hero-title title-3">Insights</span>
						<span className="hero-title title-4">With</span>
						<span className="hero-title title-5">AURAI</span>
						<span className="hero-desc desc-1">Your Intelligent</span>
						<span className="hero-desc desc-2">Digital Oracle</span>

						<div className="hero-bg">
							<CrystalScene />
						</div>

						<div className="hero-cta">
							<ButtonSecondary className="about-btn pulse-effect">
								About Aur AI
							</ButtonSecondary>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
